import { useEffect, useState } from "react";

import { classNames } from "../../utils";
import Centered from "./Centered";
import Well from "./Well";

type Props = {
  color?: string;
  size?: number;
  explanation?: React.ReactNode;
  delayMs?: number | null;
};

export default function LoadingSpinner({ size, color, explanation, delayMs }: Props) {
  size ??= 5;
  delayMs = typeof delayMs === "undefined" ? 250 : delayMs;

  const [show, setShow] = useState(delayMs === null);
  useEffect(() => {
    if (delayMs === null) return;

    const timeout = setTimeout(() => {
      setShow(true);
    }, delayMs);

    return () => clearTimeout(timeout);
  }, [delayMs]);

  return (
    <Centered>
      <div className="flex flex-col items-center gap-4">
        <svg
          className={classNames(
            `w-${size} h-${size}`,
            "animate-spin",
            color ? color : "text-black dark:text-white",
            !show && "invisible",
          )}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          data-role="loader"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {/* eslint-disable-next-line @typescript-eslint/strict-boolean-expressions */}
        {explanation && <Well className="px-3 py-2 sm:p-4">{explanation}</Well>}
      </div>
    </Centered>
  );
}
